import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Inject,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ListingDtls } from '../../shared/listing-details';
import { Listing } from '../../shared/property-details';
import { constants } from '../../shared/constants';
import { DOCUMENT } from '@angular/common';

import { LoginService } from '../../services/login.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { ToastService, ToastType } from '../../services/toast.service';
import { UserService } from '../../services/user.service';
import { ResetPasswordService } from '../../services/resetPassword.service';
import { CookieService } from 'ngx-cookie-service';
import { AppState } from 'src/app/app.state';
import { UserState } from 'src/state/user.state';
import { CookieStorageService } from 'src/app/services/cookie-storage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    public appState: AppState,
    public loginService: LoginService,
    public localStorageService: LocalStorageService,
    public toastService: ToastService,
    public userService: UserService,
    private resetPasswordService: ResetPasswordService,
    private cookieService: CookieService,
    private cookieStorageService: CookieStorageService,
    public userState: UserState
  ) { }

  form: FormGroup = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    // phone: new FormControl('', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
    phone: new FormControl('', [Validators.required]),
    // password: new FormControl('', [Validators.required, Validators.pattern('^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8,}$')]),
    password: new FormControl('', [Validators.required]),
    smsConfirmation: new FormControl(true, [Validators.required]),
  });

  submitted = false;
  hide = true;
  isLoader = false;
  isDuplicateAccount = false;
  historyState: any;
  listingDetails: ListingDtls;
  propertyDetails: Listing;
  listingPrice: any;
  listingContractDate: any;
  bedroomsTotal: any;
  bathroomsDecimal: any;
  lotSizeSquareFeet: any;
  livingArea: any;

  @ViewChild('firstName') firstName: ElementRef;
  @ViewChild('lastName') lastName: ElementRef;
  @ViewChild('email') email: ElementRef;
  @ViewChild('phone') phone: ElementRef;
  @ViewChild('password') password: ElementRef;

  ngOnInit(): void {
    this.historyState = history.state;

    if (this.historyState && this.historyState.address) {
      this.listingDetails = this.historyState.listingDetails;
      this.propertyDetails = this.historyState.propertyDetails;
      if (this.listingDetails) {
        this.listingPrice = this.listingDetails.ClosePrice;
        this.listingContractDate =
          this.listingDetails.CloseDate != ''
            ? this.listingDetails.CloseDate
            : null;
        this.bedroomsTotal =
          this.listingDetails.BedroomsTotal &&
            this.listingDetails.BedroomsTotal != ''
            ? this.listingDetails.BedroomsTotal
            : '-';
        this.bathroomsDecimal =
          this.listingDetails.BathroomsDecimal &&
            this.listingDetails.BathroomsDecimal != ''
            ? this.listingDetails.BathroomsDecimal
            : '-';
        this.lotSizeSquareFeet =
          this.listingDetails.LotSizeSquareFeet != ''
            ? this.listingDetails.LotSizeSquareFeet
            : null;
        this.livingArea =
          this.listingDetails.LivingArea != ''
            ? this.listingDetails.LivingArea
            : null;
      } else {
        this.listingPrice = this.historyState.ListPrice;
        this.listingContractDate = null;
        this.bedroomsTotal =
          this.propertyDetails.BedroomsTotal &&
            this.propertyDetails.BedroomsTotal != ''
            ? this.propertyDetails.BedroomsTotal
            : '-';
        this.bathroomsDecimal =
          this.propertyDetails.BathroomsDecimal &&
            this.propertyDetails.BathroomsDecimal != ''
            ? this.propertyDetails.BathroomsDecimal
            : '-';
        this.lotSizeSquareFeet =
          this.propertyDetails.LotSizeSquareFeet != ''
            ? this.propertyDetails.LotSizeSquareFeet
            : null;
        this.livingArea =
          this.propertyDetails.LivingArea != ''
            ? this.propertyDetails.LivingArea
            : null;
      }
    }

    const cookieExists: boolean = this.cookieService.check('idToken');
    if (cookieExists) {
      this.router.navigateByUrl('');
    }
  }

  login(): void {
    this.router.navigate(['/signin'], {
      state: this.historyState,
    });
  }

  onSubmit(): void {
    this.submitted = true;
    this.isDuplicateAccount = false;

    if (
      this.form.status == 'VALID' &&
      this.form.value.smsConfirmation == true
    ) {
      this.isLoader = true;
      let input = {
        firstName: this.form.value.firstname,
        lastName: this.form.value.lastname,
        email: this.form.value.email.toLowerCase(),
        phone: this.form.value.phone.replace(/[^+\d]+/g, ''),
        password: this.form.value.password,
        hostUserId: '',
        sendMail: false,
        source: 'sellerApp',
        leadType: 'seller',
        smsConfirmation: this.form.value.smsConfirmation,
      };
      this.loginService.UserSignUp(input).subscribe({
        next: (res) => {
          if (
            res &&
            res.message == 'Success' &&
            res.data &&
            res.data.activationUrl
          ) {
            this.loginUser(input.email, input.password);
          } else {
            this.isLoader = false;
            console.log('Login Fails!!!!');
            this.isDuplicateAccount = true;
          }
        },
        error: (err) => {
          console.log('err : ', err);
          this.isDuplicateAccount = true;
          this.isLoader = false;
        },
      });
    }
  }

  loginUser(userName, password) {
    let loginInput = {
      userName: userName,
      password: password,
    };
    this.loginService.UserLogin(loginInput).subscribe({
      next: (res) => {
        if (
          res &&
          res.refreshToken
        ) {
          this.isLoader = false;

          this.cookieStorageService.setCookie('accessToken', res.accessToken);
          this.cookieStorageService.setCookie('refreshToken', res.refreshToken);
          this.cookieStorageService.setCookie('idToken', res.idToken);

          this.getUserInfo(loginInput.userName);
        } else {
          this.isLoader = false;
          console.log('Login Fails!!!!');
          this.router.navigateByUrl('/signin', {
            state: this.historyState,
          });
        }
      },
      error: (err) => {
        this.isLoader = false;
        console.log('UserLogin : err :', err);
        this.router.navigateByUrl('/signin', {
          state: this.historyState,
        });
      },
    });
  }

  getUserInfo(userName) {
    let input = {
      where: {
        email: encodeURIComponent(userName),
      },
    };
    this.userService.GetUsers(input).subscribe({
      next: (res) => {
        if (res && res.length > 0) {
          let user = res[0];
          user['userFullName'] = user.firstName + ' ' + user.lastName;
          user['userName'] = userName;
          this.userState.getUserDetails = user;

          this.verifyEmail(user.id, userName, user.userFullName);

          this.isLoader = false;
          if (this.historyState && this.historyState.address) {
            this.router.navigateByUrl('/home-details', {
              state: this.historyState,
            });
          } else if (this.localStorageService.get('addressInfo')) {
            this.router.navigateByUrl('/search');
          } else {
            this.router.navigateByUrl('');
          }
        } else {
          this.isLoader = false;
          this.toastService.toast('Get User Data Fails!!!!', ToastType.Error);
          console.log('GetUsers Fails!!!! : ', res);
        }
      },
      error: (err) => {
        this.isLoader = false;
        this.toastService.toast(
          'Error while getting User data!!!',
          ToastType.Error
        );
        console.log('GetUsers err : ', err);
      },
    });
  }

  verifyEmail(userId, emailAddress, toName) {
    let url =
      "https://" + this.appState.companyInfoValue?.sellBaseUrl +
      '/validate-email' +
      '?userId=' +
      userId;

    let sendMsgInput = {
      to: emailAddress,
      toName: toName,
      url: url,
      messageId: constants.verify_email_messageId,
      subject: constants.verify_email_subject,
      from: constants.verify_email_from,
      fromName: constants.verify_email_fromName,
    };
    this.resetPasswordService.sentMessage(sendMsgInput).subscribe({
      next: (res) => {
        if (res && res.status.code == 200 && res.status.message == 'Success') {
          this.toastService.toast(
            'Verification email send to the registered email!!!!',
            ToastType.Information
          );
        } else {
          console.log('email sending failed');
        }
      },
    });
  }

  changepasswordIcon() {
    this.hide = !this.hide;
  }

  transferFocus(event: KeyboardEvent, nextNode: HTMLInputElement) {
    event.preventDefault();
    nextNode.focus();
  }

  logInWithIDP(idp) {
    let redirectionUrl = `${this.appState?.companyInfoValue?.awsCognitoConfig.userPoolDomainUrl}/oauth2/authorize?client_id=${this.appState?.companyInfoValue?.awsCognitoConfig.clientId}&redirect_uri=${this.appState?.companyInfoValue?.awsCognitoConfig.redirectUrl}&response_type=code&identity_provider=${idp}`;
    // let redirectionUrl = `${this.appState?.companyInfoValue?.awsCognitoConfig.userPoolDomainUrl}/oauth2/authorize?client_id=${this.appState?.companyInfoValue?.awsCognitoConfig.clientId}&redirect_uri=${environment.redirectUrl}&response_type=code&identity_provider=${idp}`;
    // let redirectionUrl = `${environment.userPoolDomainUrl}/oauth2/authorize?client_id=${environment.clientId}&redirect_uri=${environment.redirectUrl}&response_type=code&identity_provider=${idp}`;
    if (idp == 'SignInWithGoogle') {
      this.document.location.href = redirectionUrl;
    } else {
      this.document.location.href = redirectionUrl;
    }
  }
}
